export const translations = {
	nav: {
		title: 'Navigazione',
		app: 'Certificato di donazione',
	},
	footer: {
		poweredBy: 'Realizzato da',
		copyright: '© {{year}} WorldCoo. Tutti i diritti riservati.',
		termsAndConditions: 'Termini e condizioni',
		privacyPolicy: 'Informativa sulla privacy',
	},
	categories: {
		basicNeeds: 'Acqua ed Energia',
		humanRights: 'Diritti Umani',
		education: 'Istruzione',
		emergency: 'Emergenze',
		feeding: 'Fame e Sicurezza Alimentare',
		environment: 'Ambiente',
		habitat: 'Abitazione e Povertà',
		health: 'Salute',
	},
	statistics: {
		campaigns: 'Campagne',
		donations: 'Donazioni',
		collected: 'Raccolto',
		collectedFromBudget: 'Obiettivo di {{budget}}',
	},
	filters: {
		year: 'Anno',
		state: 'Stato',
		cause: 'Causa',
		active: 'Attiva',
		finished: 'Terminata',
		default: 'Predefinito',
		toggle: 'Attiva/disattiva {{value}}',
	},
	actions: {
		close: 'Chiudi',
		search: 'Cerca qualsiasi cosa',
		filter: 'Filtra',
		viewCampaign: 'Visualizza campagna',
		makeDonation: 'Fai una donazione',
		donate: 'Dona',
		selectLanguage: 'Seleziona lingua',
		backToHome: 'Torna alla home',
		funded: 'Finanziato',
		clear: 'Pulisci filtri',
		apply: 'Applica',
		goBack: 'Indietro',
		previous: 'Precedente',
		next: 'Successivo',
	},
	portal: {
		heroButton: 'Inizia a donare',
		campaigns: {
			title: 'Campagne',
			description: 'Esplora le nostre iniziative e scegli la causa che più ti ispira',
			notFound: 'Nessuna campagna',
		},
		campaignFunded: 'Campagna finanziata',
		percentageFunded: '{{percentage}}% Finanziata',
		aCampaignFrom: 'Una campagna di: {{ngoName}}',
		beneficiaries: 'Beneficiari',
		directBeneficiaries: '{{count}} diretti',
		indirectBeneficiaries: '{{count}} indiretti',
		sdgs: {
			title: 'Obiettivi di Sviluppo Sostenibile',
			1: 'Sconfiggere la Povertà',
			2: 'Sconfiggere la Fame',
			3: 'Salute e Benessere',
			4: 'Istruzione di Qualità',
			5: 'Parità di Genere',
			6: 'Acqua Pulita e Servizi Igienico-sanitari',
			7: 'Energia Pulita e Accessibile',
			8: 'Lavoro Dignitoso e Crescita Economica',
			9: 'Imprese, Innovazione e Infrastrutture',
			10: 'Ridurre le Disuguaglianze',
			11: 'Città e Comunità Sostenibili',
			12: 'Consumo e Produzione Responsabili',
			13: 'Lotta contro il Cambiamento Climatico',
			14: "Vita sott'Acqua",
			15: 'Vita sulla Terra',
			16: 'Pace, Giustizia e Istituzioni Solide',
			17: 'Partnership per gli Obiettivi',
		},
	},
	faq: {
		title: 'Domande frequenti',
		description: 'Risposte alle domande più comuni dei nostri donatori.',
	},
	campaign: {
		objectives: 'Obiettivi della campagna',
		description: 'Descrizione',
		activities: 'Attività',
		beneficiaries: 'Chi ne beneficerà?',
		updatesAndLinks: 'Ulteriori informazioni e link',
		from: 'Dal:',
		until: 'Al:',
	},
	campaigns: {
		notTranslated: 'Questo progetto non è ancora disponibile nella tua lingua.',
	},
	placeholders: {
		amount: 'Altra quantità',
	},
	donate: {
		title: 'Fai la tua donazione',
		details: {
			title: 'Aggiungi i tuoi dati per continuare',
			subtitle:
				'Completa i tuoi dati per finalizzare la tua donazione. Puoi anche richiedere il tuo certificato fiscale qui.',
		},
		certificate: {
			title: 'Recupera fino a {{amount}}',
			subtitle:
				'Certifica la tua donazione con un clic e apparirà automaticamente nella tua bozza di dichiarazione dei redditi.',
		},
	},
	errors: {
		required: 'Questo campo è obbligatorio',
		invalidExtref: 'Il codice non è valido, deve seguire questo formato: {{format}}',
		email: "L'indirizzo e-mail non è formattato correttamente.",
		emailAlreadyExists: 'Questa e-mail è già in uso.',
		password: 'La tua password deve contenere almeno 6 caratteri.',
		confirmationCode: 'Inserisci il codice di conferma.',
		documentType: 'Tipo di documento non valido',
		termsAndConditions: 'Devi accettare i termini e le condizioni',
		amount: 'Per favore, seleziona o inserisci un importo valido.',
		signIn: 'Errore durante l’accesso',
		emailsDoNotMatch: 'Gli indirizzi e-mail non corrispondono.',
		passwordsDoNotMatch: 'Le password non corrispondono.',
		imageFormat: 'Trascina un file immagine',
		camera: 'Impossibile accedere alla fotocamera. Assicurati di aver concesso l’autorizzazione.',
		expiredCode: 'Il codice è scaduto.',
		codeMismatch: 'Il codice non è corretto. Riprova.',
		notAuthorized: 'Credenziali errate. Riprova.',
		userDoesNotExist: 'L’utente non esiste.',
		userNotConfirmed: 'Utente non confermato. Conferma prima il tuo indirizzo e-mail.',
		userAlreadyConfirmed: 'L’utente è già stato confermato.',
		documentNumberExists: 'Il numero del documento è già in uso.',
		limitExceeded: 'Hai raggiunto il limite di tentativi. Riprova più tardi.',
		invalidPassword: 'La password non è valida, deve contenere almeno 6 caratteri e non può contenere spazi.',
		captchaFailed: 'La verifica CAPTCHA è fallita. Riprova.',
		internal: 'Siamo spiacenti, si è verificato un problema, il nostro team è già stato informato, riprova più tardi.',
	},
	documentTypes: {
		id: 'CIE',
		passport: 'Passaporto',
		taxId: 'Codice fiscale',
		nie: 'NIE',
		others: 'Altri',
	},
	labels: {
		code: 'Codice',
		email: 'Email',
		repeatEmail: 'Ripeti la tua email',
		password: 'Password',
		confirmPassword: 'Conferma password',
		amount: 'Importo donazione',
		documentType: 'Tipo di documento',
		documentNumber: 'Numero di documento',
		name: 'Nome',
		lastName: 'Cognome',
		streetName: 'Nome della via',
		streetNumber: 'Numero',
		additionalInfo: 'Informazioni aggiuntive',
		postalCode: 'CAP',
		city: 'Città',
		country: 'Paese',
		region: 'Regione',
		province: 'Provincia',
		certificate: 'Voglio ricevere un certificato fiscale',
		termsAndConditions1:
			'Queste informazioni saranno condivise solo con le organizzazioni beneficiarie delle tue donazioni al fine di generare il relativo certificato fiscale. Leggi i ',
		termsAndConditions2: 'termini e condizioni',
		language: 'Lingua',
		newsletter:
			'Iscriviti per rimanere aggiornato sulle cause che sosteniamo, i progetti che finanziamo e le persone che sosteniamo in tutto il mondo.',
	},
	checkout: {
		title: 'Metodo di pagamento',
	},
	recaptcha: {
		description: 'protetto da reCAPTCHA.',
		privacy: 'Privacy',
		terms: 'Termini',
	},
	thanks: {
		title: 'Grazie\n per la tua donazione!',
		description:
			"A breve riceverai un'email di conferma con tutti i dettagli. Insieme stiamo costruendo un futuro migliore!",
	},
	termsAndConditions: {
		title: 'Termini di Protezione dei dati',
		labelText: 'Ho letto, compreso e accetto i termini di ',
		labelLink: 'Protezione dei Dati di {{name}}',
		accept: 'Ho letto, compreso e accetto',
		responsible: {
			title: 'Responsabile',
			description: 'WORLDCOO S.L.',
		},
		purpose: {
			title: 'Finalità',
			description:
				"Gestire il rapporto commerciale in tutti i suoi ambiti, così come la tua donazione e la tua richiesta di certificato, e l'invio di comunicazioni commerciali per via elettronica.",
			descriptionNgo:
				"La raccolta fondi per progetti delle ONG, tenerti informato sulla ONG e sull'evoluzione del progetto per il quale hai donato fondi e l'emissione di certificati di detrazione fiscale.",
		},
		legitimacy: {
			title: 'Legittimità',
			description: "La base legale per il trattamento dei tuoi dati è l'ottenimento del tuo consenso.",
		},
		recipients: {
			title: 'Destinatari',
			description: 'I dati non verranno trasferiti a terzi a meno che non vi sia un obbligo legale di farlo.',
		},
		rights: {
			title: 'Diritti',
			description:
				'Hai il diritto di accedere, rettificare e cancellare i dati, così come altri diritti, come spiegato nelle informazioni aggiuntive.',
		},
		additionalInfo: {
			title: 'Informazioni aggiuntive',
			description:
				'Puoi consultare informazioni aggiuntive e dettagliate sulla Protezione dei Dati sulla nostra pagina <a href="https://www.worldcoo.com/gdpr">web</a> o contattando <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>.',
			descriptionNgo:
				'Puoi consultare le informazioni aggiuntive e dettagliate sulla Protezione dei Dati sul sito web di ogni ONG.\n\n<b>{{ngoName}}</b>',
		},
	},
};
